import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Hizmetlerimiz from "../pages/hizmetlerimiz/page";
import Parsiyel from "../pages/hizmetlerimiz/parsiyel/page";
import KompleArac from "../pages/hizmetlerimiz/komple-arac/page";
import EvOfis from "../pages/hizmetlerimiz/ev-ofis-tasima/page";
import HizliKargo from "../pages/hizmetlerimiz/hizli-kargo/page";
import NedenBiz from "../pages/neden-biz/page";
import Referanslar from "../pages/referanslar/page";
import Iletisim from "../pages/iletisim/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/hizmetlerimiz", element: <Hizmetlerimiz /> },
  { path: "/hizmetlerimiz/parsiyel", element: <Parsiyel /> },
  { path: "/hizmetlerimiz/komple-arac", element: <KompleArac /> },
  { path: "/hizmetlerimiz/ev-ofis-tasima", element: <EvOfis /> },
  { path: "/hizmetlerimiz/hizli-kargo", element: <HizliKargo /> },
  { path: "/neden-biz", element: <NedenBiz /> },
  { path: "/referanslar", element: <Referanslar /> },
  { path: "/iletisim", element: <Iletisim /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
